import CampaignTypeBadge from '@cohort/merchants/components/campaigns/CampaignTypeBadge';
import {IconBadge} from '@cohort/merchants/components/IconBadge';
import type {CampaignType} from '@cohort/shared/schema/common/campaign';
import type {OwnershipObtentionType} from '@cohort/shared/schema/common/ownerships';
import {ArrowCircleRight, PaperPlaneRight} from '@phosphor-icons/react';
import {useTranslation} from 'react-i18next';
import {match} from 'ts-pattern';

type OwnershipObtentionTypeBadgeProps = {
  obtentionType: OwnershipObtentionType;
  campaignName?: string;
  campaignType?: CampaignType;
};

const OwnershipObtentionTypeBadge: React.FC<OwnershipObtentionTypeBadgeProps> = ({
  obtentionType,
  campaignName,
  campaignType,
}) => {
  const {t} = useTranslation('pages', {
    keyPrefix: 'digitalAssetCollections.digitalAssetCollection.owners.ownershipObtentionTypeBadge',
  });
  const badgeData = match(obtentionType)
    .with('ordered', 'journey', () => (
      <div className="flex items-center gap-4 truncate">
        {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
        <CampaignTypeBadge type={campaignType!} size="small" />
        <h3 className="truncate text-xs font-medium text-gray-500">{campaignName}</h3>
      </div>
    ))
    .with('airdrop', () => (
      <IconBadge
        icon={<PaperPlaneRight className="mr-1 h-4 w-4 -rotate-90 text-primary" />}
        text={t('airdropType')}
      />
    ))
    .with('imported', () => (
      <IconBadge
        icon={<ArrowCircleRight className="mr-1 h-4 w-4 text-yellow-500" />}
        text={t('transferType')}
      />
    ))
    .exhaustive();

  return badgeData;
};

export default OwnershipObtentionTypeBadge;
